import React from "react";
import { Box, Typography } from "@mui/material"
import UseFulLinks from "./UseFulLinks";
const About = () => {

    return(
    <Box style={{height:"74vh",backgroundColor:"white"}}>
        <UseFulLinks />
    </Box> 
)}
export default About;